module.exports = __webpack_public_path__ + "static/media/check.2f90c844.svg";